"use client";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import "./informationalVideos.scss";
import VideoCard from "./VideoCard/VideoCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchHowItWorks, selectAllHowItWorks } from "@/slice/howItsWorkSlice";
import { useEffect } from "react";
import { useIntl } from "react-intl";

export default function InformationalVideos({ itemsPerPage, data }) {
  const dispatch = useDispatch();
  const howItWorksData = useSelector(selectAllHowItWorks);
  const intl = useIntl();
  const lang = useSelector((state) => state.locale.locale);
  useEffect(() => {
    if (!data) {
      dispatch(fetchHowItWorks(lang));
    }
  }, [lang, data, dispatch]);

  const howItWorks = data?.data || howItWorksData;

  return (
    <div className="infoVideosBg">
      <div className="infoVideosWrapper">
        <p className="infoVideoHeading">
          {intl.formatMessage({ id: "howIt" })}{" "}
          <span className="highlight">
            {intl.formatMessage({ id: "work" })}
          </span>
        </p>
        {howItWorks?.length > 0 && (
          <div className="infoVideosCarousel">
            <CustomCarousel
              itemsPerPage={itemsPerPage}
              className="px-0"
              itemWidth={320}
            >
              {howItWorks?.map((video, i) => (
                <div key={i} className="infoVideosCarouselItem">
                  <VideoCard video={video} />
                </div>
              ))}
            </CustomCarousel>
          </div>
        )}
      </div>
    </div>
  );
}
